export enum AxisType {
    Row,
    Column,
}
